import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Pagination from '../../common/components/elements/Pagination';
import {
  PurchasedQuotationsStyles,
  PageHeader,
  ActionButton,
  FilterCard,
  SearchButton,
  EmptyState,
  LoadingState,
  QuotationsList,
} from './PurchasedQuotations.styles';
import {
  BrokerListItemCard,
  BrokerListItemHeader,
  BrokerListItemContent,
  BrokerListItemSection,
  BrokerListItemLabel,
  BrokerListItemValue,
  // BrokerListItemStatusBadge, // not used — using ActionButton for colored variants
  BrokerListItemAction,
} from '../../common/components/BrokerListItem.styles';
import { listQuotationsSemestralToPay, resetQuotationsSemestralToPay } from '../../features/quotations/quotationsActions';
import { generalAlertError } from '../../common/utils/alerts';
import { downloadFile } from '../../services/axios-client/axeHelpers';
// import { useTourContext } from '../../context/useTourContext';
import managementAxe from '../../services/axios-client/managementServisAxeClient';
import ErrorComponent from '../../common/components/ErrorComponent';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackSemestralityQuotes } from '../../common/utils/joyrideCallbacks';
// import { semestralityQuotesToBePaidSteps } from '../../common/utils/joyrideSteps';

function SemestalityQuotesToBePaid() {
  const state = useSelector((store) => store.quotations.quotations_semestral);

  const {
    quotations, loading, page_number, total_pages, error,
  } = state;

  const emptyFilters = {
    customer_name: '',
    vehicle_plate: '',
    date_from: '',
    date_to: '',
  };

  const [search, setSearch] = useState(emptyFilters);
  const [filtersCleared, setFiltersCleared] = useState(false);

  // const [steps, setSteps] = useState([]);

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('quoteSemestraleDaPagare') === 'done') {
  //     setState({ run: false });
  //   } else if (loading === false) {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 3000);
  //   }
  // }, [localStorage.getItem('quoteSemestraleDaPagare'), loading]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('quoteSemestraleDaPagare');
  //   setState({ run: true, tourActive: true });
  // };

  // useEffect(() => {
  //   semestralityQuotesToBePaidSteps(quotations, setSteps);
  // }, [quotations]);

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  const searchHandler = (e) => {
    e.preventDefault();

    if (search.date_from !== '' && search.date_to === '') {
      generalAlertError('Devi selezionare anche data al');
      return;
    }

    if (search.date_from === '' && search.date_to !== '') {
      generalAlertError('Devi selezionare anche data da');
      return;
    }

    const trimmedSearch = {
      ...search,
      customer_name: (search.customer_name || '').trim(),
      vehicle_plate: (search.vehicle_plate || '').trim(),
    };

    setFiltersCleared(false);
    listQuotationsSemestralToPay(1, trimmedSearch);
  };

  const downloadExel = async () => {
    const res = await managementAxe.get('/broker/download/semestrale', {
      responseType: 'blob',
    });
    downloadFile(res.data);
  };

  const getSemestaleData = (date) => moment(date).add(6, 'months');

  useEffect(() => () => {
    resetQuotationsSemestralToPay();
  }, []);

  return error === null ? (
    <PurchasedQuotationsStyles>
      <div className="container-fluid">
        <PageHeader>
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <h2>💰 Lista Quotazioni Semestrali da Pagare</h2>
            <button
              className="btn btn-success quote-semestrale-da-pagare-one"
              onClick={() => downloadExel()}
              style={{
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                fontWeight: '500',
                fontSize: '0.95rem',
                background: 'linear-gradient(135deg, #00a651 0%, #008a44 100%)',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0, 166, 81, 0.2)',
              }}
            >
              📥 Scarica Excel
            </button>
          </div>
        </PageHeader>

        <div className="row">
          <div className="col-12 mb-4">
            <FilterCard className="quote-semestrale-da-pagare-top">
              <form onSubmit={searchHandler}>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label htmlFor="customer_name" className="form-label small">Contraente</label>
                    <input
                      type="text"
                      name="customer_name"
                      id="customer_name"
                      className="form-control form-control-sm"
                      value={search.customer_name}
                      onChange={handleChange}
                      placeholder="Nome, cognome..."
                    />
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="vehicle_plate" className="form-label small">Targa</label>
                    <input
                      type="text"
                      name="vehicle_plate"
                      id="vehicle_plate"
                      className="form-control form-control-sm"
                      value={search.vehicle_plate || ''}
                      onChange={handleChange}
                      placeholder="Targa..."
                    />
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="date_from" className="form-label small">Data da</label>
                    <input
                      type="date"
                      name="date_from"
                      id="date_from"
                      onChange={handleChange}
                      value={search.date_from}
                      className="form-control form-control-sm"
                      lang="it-IT"
                    />
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="date_to" className="form-label small">Data al</label>
                    <input
                      type="date"
                      name="date_to"
                      id="date_to"
                      className="form-control form-control-sm"
                      onChange={handleChange}
                      value={search.date_to}
                      min={search.date_from}
                      lang="it-IT"
                    />
                  </div>
                </div>

                <div className="d-flex gap-2 mt-3" style={{ justifyContent: 'flex-start' }}>
                  <SearchButton type="submit" style={{ padding: '8px 24px', fontSize: '14px', width: 'auto' }}>
                    Cerca
                  </SearchButton>
                  <SearchButton
                    type="button"
                    onClick={() => {
                      setFiltersCleared(true);
                      setSearch(emptyFilters);
                      resetQuotationsSemestralToPay();
                    }}
                    style={{
                      background: '#6c757d',
                      borderColor: '#6c757d',
                      padding: '8px 24px',
                      fontSize: '14px',
                      width: 'auto',
                    }}
                  >
                    Pulisci Filtri
                  </SearchButton>
                </div>
              </form>
            </FilterCard>
          </div>

          {/* Main Content */}
          <div className="col-12">
            {loading && !filtersCleared ? (
              <LoadingState className="quote-semestrale-da-pagare-two">
                <div className="spinner-border" role="status" />
                <span>Caricamento quotazioni in corso...</span>
              </LoadingState>
            ) : (
              <>
                <QuotationsList className="quote-semestrale-da-pagare-two">
                  {quotations.length > 0 ? (
                    quotations.map((quote, index) => {
                      const semestraleData = getSemestaleData(quote.policy_effective_date);

                      const headerTitle = `${quote.product ? quote.product.name : 'Prodotto'} - ${quote.customer ? `${quote.customer.name} ${quote.customer.surname}` : ''}`;

                      const getStatusInfo = () => {
                        if (quote.status === 7 && quote.payments.length === 2) {
                          return { label: '✅ Emessa', variant: 'success' };
                        }
                        if (quote.status === 7 && quote.payments.length === 1) {
                          return { label: '⏳ Non Scaduto', variant: 'warning' };
                        }
                        if (quote.status === 4) {
                          return { label: '⚠️ Paga Semestralità', variant: 'danger' };
                        }
                        if (quote.status === 6) {
                          return { label: '💳 Pagato', variant: 'secondary' };
                        }
                        return { label: 'Sconosciuto', variant: 'secondary' };
                      };

                      const getProductUrl = () => {
                        const urlMap = {
                          1: '/quotes/auto/purchase/',
                          2: '/quotes/moto/purchase/',
                          3: '/quotes/autocarro/purchase/',
                          13: '/quotes/ancillari-auto/purchase/',
                        };
                        if (quote.is_offline === 1) {
                          return `/quotes/offline/purchase/${quote.request_token}`;
                        }
                        return urlMap[quote.product_id] ? `${urlMap[quote.product_id]}${quote.request_token}` : '#';
                      };

                      const statusInfo = getStatusInfo();

                      return (
                        <BrokerListItemCard key={index} className="quote-semestrale-da-pagare-three">
                          <BrokerListItemHeader>
                            <h4>{headerTitle}</h4>
                            <p>{quote.created_at ? `Nuovo preventivo calcolato il ${moment(quote.created_at).format('L')}` : ''}</p>
                          </BrokerListItemHeader>

                          <BrokerListItemContent>
                            <div className="row">
                              <div className="col-md-4">
                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Contraente</BrokerListItemLabel>
                                  <BrokerListItemValue>{quote.customer ? `${quote.customer.name} ${quote.customer.surname}` : '-'}</BrokerListItemValue>
                                </BrokerListItemSection>

                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Prodotto</BrokerListItemLabel>
                                  <BrokerListItemValue>{quote.product ? quote.product.name : '-'}</BrokerListItemValue>
                                </BrokerListItemSection>

                                {quote.company && quote.company.name && (
                                  <BrokerListItemSection>
                                    <BrokerListItemLabel>Compagnia</BrokerListItemLabel>
                                    <BrokerListItemValue>{quote.company.name}</BrokerListItemValue>
                                  </BrokerListItemSection>
                                )}

                                {(quote.vehicle?.vehicle_plate || quote.moto?.moto_plate) && (
                                  <BrokerListItemSection>
                                    <BrokerListItemLabel>Targa</BrokerListItemLabel>
                                    <BrokerListItemValue>
                                      {quote.vehicle?.vehicle_plate || quote.moto?.moto_plate}
                                    </BrokerListItemValue>
                                  </BrokerListItemSection>
                                )}

                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Decorrenza</BrokerListItemLabel>
                                  <BrokerListItemValue>{quote.policy_effective_date ? moment(quote.policy_effective_date).format('L') : '-'}</BrokerListItemValue>
                                </BrokerListItemSection>

                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Scadenza (Semestrale)</BrokerListItemLabel>
                                  <BrokerListItemValue>{semestraleData.format('L')}</BrokerListItemValue>
                                </BrokerListItemSection>
                              </div>

                              <div className="col-md-4">
                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Garanzie incluse</BrokerListItemLabel>
                                  <BrokerListItemValue>
                                    {Array.isArray(quote.guarantees) && quote.guarantees.length > 0 ? (
                                      <div className="d-flex flex-column" style={{ gap: '0.4rem' }}>
                                        {quote.guarantees.map((guarantee, guaranteeIndex) => (
                                          <div key={guaranteeIndex} style={{ fontSize: '0.85rem' }}>
                                            <span style={{ fontWeight: '500', color: '#333' }}>
                                              {guarantee.name}
                                              :
                                            </span>
                                            {' '}
                                            <span style={{ color: '#00a651', fontWeight: '600' }}>
                                              €
                                              {' '}
                                              {Number(guarantee.price || 0).toLocaleString('it-IT', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </span>
                                          </div>
                                        ))}
                                        {Number(quote.brokerage_amount || 0) !== 0 && (
                                          <div style={{ fontSize: '0.85rem' }}>
                                            <span style={{ fontWeight: '500', color: '#333' }}>
                                              Brokeraggio:
                                            </span>
                                            {' '}
                                            <span style={{ color: '#00a651', fontWeight: '600' }}>
                                              €
                                              {' '}
                                              {Number(quote.brokerage_amount).toLocaleString('it-IT', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div style={{ color: '#999', fontSize: '0.85rem', fontStyle: 'italic' }}>
                                        Nessuna garanzia selezionata
                                      </div>
                                    )}
                                  </BrokerListItemValue>
                                </BrokerListItemSection>

                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Totale</BrokerListItemLabel>
                                  <BrokerListItemValue style={{ color: '#00a651', fontWeight: 700 }}>
                                    €
                                    {' '}
                                    {(
                                      (Array.isArray(quote.guarantees) && quote.guarantees.length > 0
                                        ? quote.guarantees.reduce((sum, g) => sum + Number(g.price || 0), 0)
                                        : Number(quote.amount || 0))
                                      + Number(quote.brokerage_amount || 0)
                                    ).toLocaleString('it-IT', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </BrokerListItemValue>
                                </BrokerListItemSection>
                              </div>

                              <div className="col-md-4 d-flex flex-column justify-content-between align-items-end">
                                <div>
                                  {quote.status === 4 ? (
                                    <ActionButton
                                      as={Link}
                                      to={getProductUrl()}
                                      $variant={statusInfo.variant}
                                      style={{ padding: '0.4rem 0.85rem', fontSize: '0.85rem' }}
                                    >
                                      {statusInfo.label}
                                    </ActionButton>
                                  ) : (
                                    <ActionButton
                                      $variant={statusInfo.variant}
                                      style={{ padding: '0.4rem 0.85rem', fontSize: '0.85rem' }}
                                    >
                                      {statusInfo.label}
                                    </ActionButton>
                                  )}
                                </div>
                                <div>
                                  <BrokerListItemAction as={Link} to={getProductUrl()}>Vai al preventivo</BrokerListItemAction>
                                </div>
                              </div>
                            </div>
                          </BrokerListItemContent>
                        </BrokerListItemCard>
                      );
                    })
                  ) : (
                    <EmptyState className="quote-semestrale-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Trova con facilità le quotazioni semestrali che cerchi</h5>
                      <p>
                        Utilizza i filtri per trovare una quotazione o clicca su &quot;Cerca&quot; per visualizzare le ultime quotazioni semestrali
                      </p>
                    </EmptyState>
                  )}
                </QuotationsList>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={listQuotationsSemestralToPay}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </PurchasedQuotationsStyles>
  ) : <ErrorComponent error={error} />;
}

export default SemestalityQuotesToBePaid;
